import React from 'react'

export const ProposalDocsIcon = (props) => (
    <svg 
        fill="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg" 
        id="file-reload" 
        className="icon glyph"
        {...props}
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path 
                d="M18,7.41V9.15A7.51,7.51,0,0,0,9,16.5,7.35,
                7.35,0,0,0,10.52,21H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,
                2h8.59A2,2,0,0,1,14,2.59L17.41,6A2,2,0,0,1,
                18,7.41ZM21,10a1,1,0,0,0-1,1v1.28A5.49,5.49,0,1,0,
                20.78,20a1,1,0,1,0-1.56-1.26A3.45,3.45,0,0,1,16.5,
                20,3.5,3.5,0,1,1,19,14H17a1,1,0,0,0,0,2h4a1,1,0,0,0,
                1-1V11A1,1,0,0,0,21,10Z"
            >
            </path>
        </g>
    </svg>
);

